import styled from 'styled-components'
import { Body12, BodyPrimary } from 'components/Typography'
import theme from 'theme_'

export const ProfilesMobileBlockKebabItemWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: ${theme.spacing.xs};
`

export const ProfilesBody12 = styled(Body12)`
  color: ${theme.colors.darkeyGrey};
`

export const ProfilesBodyPrimary = styled(BodyPrimary)`
  color: ${theme.colors.otterWarmBlack};
`
